'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$2() {
  this.bez = null;
  this.bex = null;
  this.bey = false;
  this.bev = null;
  this.bew = false;
  this.beA = false;
  this.beB = false;
  this.bez = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$2 as $c_Lpresto_PrestoRouter$$anon$2 };
$p = $c_Lpresto_PrestoRouter$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$2;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$2() {
}
export { $h_Lpresto_PrestoRouter$$anon$2 as $h_Lpresto_PrestoRouter$$anon$2 };
$h_Lpresto_PrestoRouter$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bez;
});
$p.t = (function() {
  if ((!this.bey)) {
    this.bex = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bey = true;
  }
  return this.bex;
});
$p.ad = (function() {
  if ((!this.bew)) {
    this.bev = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bew = true;
  }
  return this.bev;
});
$p.v = (function() {
  if ((!this.beB)) {
    this.beA = false;
    this.beB = true;
  }
  return this.beA;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$2, "presto.PrestoRouter$$anon$2", ({
  NT: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$2 as $d_Lpresto_PrestoRouter$$anon$2 };
//# sourceMappingURL=presto.-Presto-Router$$anon$2.js.map
